import gsap from 'gsap';

const BREAKPOINT = 768;

gsap.defaults({
  duration: 0.2,
  ease: 'power3.inOut',
});

class Filters {
  constructor(parent) {
    this.parentSelector = parent;
    this.toggleSelector = `${parent} .js-filter-toggle`;
    this.filtersSelector = `${parent} .js-filters`;

    this.parent = document.querySelector(this.parentSelector);
    this.button = document.querySelector(this.toggleSelector);
    this.filtersIsOpen = false;

    if (this.button) {
      gsap.set(this.filtersSelector, { height: 0, y: -3, overflow: 'hidden', autoAlpha: 0 });
      this.resize();
      this.bindEvents();
    }
  }

  close() {
    this.filtersIsOpen = false;
    this.button.classList.remove('search-refinement-title--open');
    this.parent.classList.remove('search-refinement-attribute--open');

    this.tl = gsap.timeline();
    gsap.set(this.filtersSelector, { height: 'auto' });
    this.tl
      .to(this.filtersSelector, { duration: 0.3, autoAlpha: 0 })
      .to(this.filtersSelector, { height: 0, delay: 0.05 }, '<')
      .to(this.filtersSelector, { y: -3 }, '<');
  }

  open() {
    this.filtersIsOpen = true;
    this.button.classList.add('search-refinement-title--open');
    this.parent.classList.add('search-refinement-attribute--open');

    this.tl = gsap.timeline();
    gsap.set(this.filtersSelector, { height: 'auto' });
    this.tl
      .from(this.filtersSelector, { height: 0 })
      .to(this.filtersSelector, { duration: 0.3, autoAlpha: 1 }, '<')
      .to(this.filtersSelector, { y: 0, delay: 0.05 }, '<')
      .to(this.filtersSelector, { height: '100%' });
  }

  toggle() {
    if (this.filtersIsOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  resize() {
    if (window.innerWidth >= BREAKPOINT) {
      if (!this.filtersIsOpen) {
        this.open();
      }
    }
  }

  bindEvents() {
    this.button.addEventListener('click', () => this.toggle());
    window.addEventListener('resize', () => this.resize());
  }
}

export default Filters;
